module.exports = __webpack_public_path__ + "img/banner1.02e37762.jpg";